import { watch } from 'vue';
import { createI18n, type I18nOptions, type IntlDateTimeFormat } from 'vue-i18n';
import { useShellLocale } from '@/settings';
import { buildMessageTable, shellLocale } from './messages';

// The shell's own i18n instance: Connect's texts plus the shared libraries'.
// It holds no app's texts — every hosted app gets a table of its own
// (./appI18n.ts, I-2284).

const { locale: storedLocale } = useShellLocale();

// nx-ui's date columns format via the injected `d(date, 'short')`, so every
// table the kit translates with needs the 'short' format — otherwise vue-i18n
// logs "Not found 'short' key" for every date cell.
export const datetimeFormats = {
  short: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  },
} satisfies IntlDateTimeFormat;

const i18nOptions = {
  legacy: false,
  locale: storedLocale.value,
  fallbackLocale: 'de',
  messages: buildMessageTable(shellLocale) as I18nOptions['messages'],
  datetimeFormats: { de: datetimeFormats, en: datetimeFormats },
} satisfies I18nOptions;

const i18n = createI18n(i18nOptions);

// The language is the account config key `locale` (I-2510): the shell follows
// it whenever it changes — a setting, the palette, master's answer at boot.
watch(storedLocale, (next) => {
  if (i18n.global.locale.value !== next) i18n.global.locale.value = next;
});

export default i18n;
